import { createPinia } from 'pinia'
import piniaPluginPersistedState from 'pinia-plugin-persistedstate'
import { PiniaSharedState } from 'pinia-shared-state'

const store = createPinia()
store.use(piniaPluginPersistedState)
store.use(
  PiniaSharedState({
    enable: false,
    type: 'localstorage',
  }),
)

export { store }
